// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes vehicle-urgent-badge-blink {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.5; transform: scale(0.94); }
}

.header-urgent-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 34px;
  height: 20px;
  padding: 0 7px;
  border: none;
  border-radius: 999px;
  background: #dc2626;
  color: #fff;
  font-size: 10px;
  font-weight: 900;
  cursor: pointer;
  flex-shrink: 0;
  line-height: 1;
  box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.5);
  animation: vehicle-urgent-badge-blink 0.75s step-start infinite;
}

.header-urgent-badge:hover {
  background: #b91c1c;
}

.header-urgent-badge--static {
  cursor: default;
  animation: vehicle-urgent-badge-blink 0.75s step-start infinite;
}

.user-name-row {
  display: flex;
  align-items: center;
  gap: 6px;
}

.vehicle-urgent-modal {
  position: fixed;
  inset: 0;
  z-index: 9300;
  background: rgba(0, 0, 0, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}

.vehicle-urgent-modal__panel {
  width: 100%;
  max-width: 420px;
  background: #fff;
  border: 1px solid rgba(239, 68, 68, 0.25);
  border-radius: 16px;
  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.18);
  overflow: hidden;
}

.vehicle-urgent-modal__panel--list {
  max-width: 520px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.vehicle-urgent-modal__head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 16px 18px;
  background: linear-gradient(135deg, rgba(254, 226, 226, 0.95), rgba(255, 247, 237, 0.92));
  border-bottom: 1px solid rgba(239, 68, 68, 0.2);
  flex-shrink: 0;
}

.vehicle-urgent-modal__title {
  margin: 0;
  font-size: 16px;
  font-weight: 900;
  color: #991b1b;
}

.vehicle-urgent-modal__sub {
  margin: 0;
  padding: 10px 18px 0;
  font-size: 12px;
  font-weight: 600;
  color: #b45309;
  flex-shrink: 0;
}

.vehicle-urgent-modal__empty {
  padding: 24px 18px;
  text-align: center;
  color: #64748b;
  font-size: 14px;
  flex-shrink: 0;
}

.vehicle-urgent-list {
  list-style: none;
  margin: 0;
  padding: 12px 18px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  overflow-y: auto;
  flex: 1 1;
}

.vehicle-urgent-item {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 12px;
  text-align: left;
  border: 1px solid rgba(248, 113, 113, 0.45);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.95);
  padding: 10px 12px;
  cursor: pointer;
  font: inherit;
}

.vehicle-urgent-item:hover {
  border-color: rgba(220, 38, 38, 0.55);
  background: #fff;
}

.vehicle-urgent-item__type {
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 800;
  background: rgba(220, 38, 38, 0.12);
  color: #b91c1c;
}

.vehicle-urgent-item__plate {
  font-size: 14px;
  font-weight: 900;
  color: #0f172a;
}

.vehicle-urgent-item__name {
  font-size: 12px;
  color: #64748b;
}

.vehicle-urgent-item__dday {
  font-size: 12px;
  font-weight: 900;
}

.vehicle-urgent-item--danger .vehicle-urgent-item__dday {
  color: #dc2626;
}

.vehicle-urgent-item--warning .vehicle-urgent-item__dday {
  color: #d97706;
}

.vehicle-urgent-item__date {
  font-size: 12px;
  font-weight: 700;
  color: #475569;
}

.vehicle-urgent-modal__body {
  padding: 16px 18px 8px;
}

.vehicle-urgent-modal__row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
  font-size: 13px;
}

.vehicle-urgent-modal__label {
  color: #64748b;
  font-weight: 600;
  flex-shrink: 0;
}

.vehicle-urgent-modal__value {
  color: #0f172a;
  font-weight: 700;
  text-align: right;
  word-break: break-all;
}

.vehicle-urgent-modal__dday.vehicle-urgent-item--danger {
  color: #dc2626;
}

.vehicle-urgent-modal__dday.vehicle-urgent-item--warning {
  color: #d97706;
}

.vehicle-urgent-modal__hint {
  margin: 12px 0 0;
  font-size: 12px;
  line-height: 1.55;
  color: #64748b;
}

.vehicle-urgent-modal__close {
  width: calc(100% - 36px);
  margin: 12px 18px 18px;
  padding: 11px 0;
  border: none;
  border-radius: 10px;
  background: #dc2626;
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  flex-shrink: 0;
}

.vehicle-urgent-modal__close:hover {
  background: #b91c1c;
}

.vehicle-urgent-modal__close--secondary {
  background: #e2e8f0;
  color: #334155;
}

.vehicle-urgent-modal__close--secondary:hover {
  background: #cbd5e1;
}
`, "",{"version":3,"sources":["webpack://./src/components/VehicleUrgent.css"],"names":[],"mappings":"AAAA;EACE,WAAW,UAAU,EAAE,mBAAmB,EAAE;EAC5C,MAAM,YAAY,EAAE,sBAAsB,EAAE;AAC9C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;EACd,0CAA0C;EAC1C,+DAA+D;AACjE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,yFAAyF;EACzF,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["@keyframes vehicle-urgent-badge-blink {\n  0%, 100% { opacity: 1; transform: scale(1); }\n  50% { opacity: 0.5; transform: scale(0.94); }\n}\n\n.header-urgent-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 34px;\n  height: 20px;\n  padding: 0 7px;\n  border: none;\n  border-radius: 999px;\n  background: #dc2626;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 900;\n  cursor: pointer;\n  flex-shrink: 0;\n  line-height: 1;\n  box-shadow: 0 0 0 0 rgba(220, 38, 38, 0.5);\n  animation: vehicle-urgent-badge-blink 0.75s step-start infinite;\n}\n\n.header-urgent-badge:hover {\n  background: #b91c1c;\n}\n\n.header-urgent-badge--static {\n  cursor: default;\n  animation: vehicle-urgent-badge-blink 0.75s step-start infinite;\n}\n\n.user-name-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.vehicle-urgent-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 9300;\n  background: rgba(0, 0, 0, 0.55);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n\n.vehicle-urgent-modal__panel {\n  width: 100%;\n  max-width: 420px;\n  background: #fff;\n  border: 1px solid rgba(239, 68, 68, 0.25);\n  border-radius: 16px;\n  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.18);\n  overflow: hidden;\n}\n\n.vehicle-urgent-modal__panel--list {\n  max-width: 520px;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.vehicle-urgent-modal__head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 16px 18px;\n  background: linear-gradient(135deg, rgba(254, 226, 226, 0.95), rgba(255, 247, 237, 0.92));\n  border-bottom: 1px solid rgba(239, 68, 68, 0.2);\n  flex-shrink: 0;\n}\n\n.vehicle-urgent-modal__title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 900;\n  color: #991b1b;\n}\n\n.vehicle-urgent-modal__sub {\n  margin: 0;\n  padding: 10px 18px 0;\n  font-size: 12px;\n  font-weight: 600;\n  color: #b45309;\n  flex-shrink: 0;\n}\n\n.vehicle-urgent-modal__empty {\n  padding: 24px 18px;\n  text-align: center;\n  color: #64748b;\n  font-size: 14px;\n  flex-shrink: 0;\n}\n\n.vehicle-urgent-list {\n  list-style: none;\n  margin: 0;\n  padding: 12px 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  overflow-y: auto;\n  flex: 1;\n}\n\n.vehicle-urgent-item {\n  width: 100%;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px 12px;\n  text-align: left;\n  border: 1px solid rgba(248, 113, 113, 0.45);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.95);\n  padding: 10px 12px;\n  cursor: pointer;\n  font: inherit;\n}\n\n.vehicle-urgent-item:hover {\n  border-color: rgba(220, 38, 38, 0.55);\n  background: #fff;\n}\n\n.vehicle-urgent-item__type {\n  padding: 2px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 800;\n  background: rgba(220, 38, 38, 0.12);\n  color: #b91c1c;\n}\n\n.vehicle-urgent-item__plate {\n  font-size: 14px;\n  font-weight: 900;\n  color: #0f172a;\n}\n\n.vehicle-urgent-item__name {\n  font-size: 12px;\n  color: #64748b;\n}\n\n.vehicle-urgent-item__dday {\n  font-size: 12px;\n  font-weight: 900;\n}\n\n.vehicle-urgent-item--danger .vehicle-urgent-item__dday {\n  color: #dc2626;\n}\n\n.vehicle-urgent-item--warning .vehicle-urgent-item__dday {\n  color: #d97706;\n}\n\n.vehicle-urgent-item__date {\n  font-size: 12px;\n  font-weight: 700;\n  color: #475569;\n}\n\n.vehicle-urgent-modal__body {\n  padding: 16px 18px 8px;\n}\n\n.vehicle-urgent-modal__row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 0;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 13px;\n}\n\n.vehicle-urgent-modal__label {\n  color: #64748b;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.vehicle-urgent-modal__value {\n  color: #0f172a;\n  font-weight: 700;\n  text-align: right;\n  word-break: break-all;\n}\n\n.vehicle-urgent-modal__dday.vehicle-urgent-item--danger {\n  color: #dc2626;\n}\n\n.vehicle-urgent-modal__dday.vehicle-urgent-item--warning {\n  color: #d97706;\n}\n\n.vehicle-urgent-modal__hint {\n  margin: 12px 0 0;\n  font-size: 12px;\n  line-height: 1.55;\n  color: #64748b;\n}\n\n.vehicle-urgent-modal__close {\n  width: calc(100% - 36px);\n  margin: 12px 18px 18px;\n  padding: 11px 0;\n  border: none;\n  border-radius: 10px;\n  background: #dc2626;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.vehicle-urgent-modal__close:hover {\n  background: #b91c1c;\n}\n\n.vehicle-urgent-modal__close--secondary {\n  background: #e2e8f0;\n  color: #334155;\n}\n\n.vehicle-urgent-modal__close--secondary:hover {\n  background: #cbd5e1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
